/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTriggerActionTypes200Response } from '../models';
/**
 * TriggerActionTypeApi - axios parameter creator
 * @export
 */
export const TriggerActionTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * トリガーアクションタイプ一覧取得API
         * @summary トリガーアクションタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerActionTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/trigger_action_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TriggerActionTypeApi - functional programming interface
 * @export
 */
export const TriggerActionTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TriggerActionTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * トリガーアクションタイプ一覧取得API
         * @summary トリガーアクションタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTriggerActionTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTriggerActionTypes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTriggerActionTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TriggerActionTypeApi - factory interface
 * @export
 */
export const TriggerActionTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TriggerActionTypeApiFp(configuration)
    return {
        /**
         * トリガーアクションタイプ一覧取得API
         * @summary トリガーアクションタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerActionTypes(options?: any): AxiosPromise<GetTriggerActionTypes200Response> {
            return localVarFp.getTriggerActionTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TriggerActionTypeApi - interface
 * @export
 * @interface TriggerActionTypeApi
 */
export interface TriggerActionTypeApiInterface {
    /**
     * トリガーアクションタイプ一覧取得API
     * @summary トリガーアクションタイプ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerActionTypeApiInterface
     */
    getTriggerActionTypes(options?: AxiosRequestConfig): AxiosPromise<GetTriggerActionTypes200Response>;

}

/**
 * TriggerActionTypeApi - object-oriented interface
 * @export
 * @class TriggerActionTypeApi
 * @extends {BaseAPI}
 */
export class TriggerActionTypeApi extends BaseAPI implements TriggerActionTypeApiInterface {
    /**
     * トリガーアクションタイプ一覧取得API
     * @summary トリガーアクションタイプ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerActionTypeApi
     */
    public getTriggerActionTypes(options?: AxiosRequestConfig) {
        return TriggerActionTypeApiFp(this.configuration).getTriggerActionTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
